import { render } from "./modifyphone.vue?vue&type=template&id=16f285cf"
import script from "./modifyphone.vue?vue&type=script&lang=js"
export * from "./modifyphone.vue?vue&type=script&lang=js"

import "./modifyphone.vue?vue&type=style&index=0&id=16f285cf&lang=less"

import exportComponent from "F:\\ffile\\vscodeprj\\app\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__